import { Col, Row } from "antd";
import { Fragment } from "react";

import SmartImage from "../SmartImage";
import { getStyle } from "../../hooks/use-styles";

import "./style.css";

const ImageRowItem = ({
  badge,
  title,
  colSize,
  onClick,
  imageSrc,
  subTitle,
  className,
  showShadow,
  titleStyle,
  badgeClass,
  imageClass,
  titleClass,
  subTitleClass,
  subTitleStyle,
  imageRowItemClass,
  imageContainerClass,
}) => {
  const rowProps = {
    ...(onClick && { onClick }),
  };

  const subTitleProps = {
    ...(subTitleStyle && { style: subTitleStyle }),
  };

  const { col1, col2 } = colSize || { col1: null, col2: null };

  return (
    <Fragment>
      <Row {...rowProps} className={`image-row-container ${className}`}>
        <Col md={col1} sm={col1} xs={col1}>
          <div className={`image-item-container ${imageContainerClass || ""}`}>
            <SmartImage
              src={imageSrc || "/assets/icons/default-image.jpeg"}
              alt={title || ""}
              width="100%"
              height="100%"
              className={`${showShadow ? "picture-box-shadow" : ""} ${
                imageClass || ""
              }`}
            />
          </div>
        </Col>
        <Col md={col2} sm={col2} xs={col2}>
          <div className={`image-row-item ${imageRowItemClass || ""}`}>
            {title && (
              <div
                className={titleClass || "text-sm"}
                style={{
                  color: getStyle("primaryBlack"),
                  ...(titleStyle && { titleStyle }),
                }}
              >
                <span id="row-item-title" className="row-item-title">
                  {title}
                </span>
                {badge && <span className={badgeClass}>{badge}</span>}
              </div>
            )}
            {subTitle && (
              <div
                className={`${subTitleClass} text-sm`}
                {...subTitleProps}
                style={{ color: getStyle("secondaryGray") }}
              >
                {subTitle}
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ImageRowItem;
